'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
const Snapshot_1 = require('../models/Snapshot');
exports.EMPTY_SNAPSHOT = {
    evaluatorVersion: Snapshot_1.EVALUATOR_VERSION,
    projectId: '',
    templateId: '',
    dataVariables: [],
    synonymEntities: {},
    branchEntities: {},
    dataEntities: {},
    synonymFields: {},
    branchFields: {},
    draftStates: {}
};    //# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZW1wdHlTbmFwc2hvdC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9ldmFsdWF0b3Ivc25hcHNob3RSZWR1Y2Vycy9lbXB0eVNuYXBzaG90LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBQUEsd0RBQThFO0FBRWpFLFFBQUEsY0FBYyxHQUFtQjtJQUM1QyxnQkFBZ0IsRUFBRSw0QkFBaUI7SUFDbkMsU0FBUyxFQUFFLEVBQUU7SUFDYixVQUFVLEVBQUUsRUFBRTtJQUNkLGFBQWEsRUFBRSxFQUFFO0lBQ2pCLGVBQWUsRUFBRSxFQUFFO0lBQ25CLGNBQWMsRUFBRSxFQUFFO0lBQ2xCLFlBQVksRUFBRSxFQUFFO0lBQ2hCLGFBQWEsRUFBRSxFQUFFO0lBQ2pCLFlBQVksRUFBRSxFQUFFO0lBQ2hCLFdBQVcsRUFBRSxFQUFFO0NBQ2hCLENBQUMifQ==
